import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=235201ee&scoped=true&"
import script from "./Language.vue?vue&type=script&lang=javascript&"
export * from "./Language.vue?vue&type=script&lang=javascript&"
import style0 from "./Language.vue?vue&type=style&index=0&id=235201ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235201ee",
  null
  
)

export default component.exports